module.exports = __webpack_public_path__ + "img/question-title-mobile.c6075653.png";